import { ListPeopleOperationActivityQuerySchema } from '@standandforce/api-contract';
import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
const PeopleOperationActivityTypesSearchSchema = ListPeopleOperationActivityQuerySchema.shape.activityTypes;
export type PeopleOperationActivityType = NonNullable<z.infer<typeof PeopleOperationActivityTypesSearchSchema>>[number];
export function isPeopleOperationActivityType(value: string): value is PeopleOperationActivityType {
  return PeopleOperationActivityTypesSearchSchema.safeParse([value]).success;
}
export const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  activityTypes: PeopleOperationActivityTypesSearchSchema,
  personId: z.string().optional(),
  startAt: z.string().optional(),
  endAt: z.string().optional(),
  orderBy: z.enum(['occurredAt', 'activityType']).default('occurredAt'),
  orderDirection: z.nativeEnum(OrderDirection).default(OrderDirection.DESC)
});
export const PersonActivitySearchSchema = SearchSchema.omit({
  personId: true
});